/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { H1, TextLink, Text, Image, FlexContainer } from "@carrotfertility/carotene"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"

const headerText = defineMessage({ defaultMessage: "Something’s not working" })

export function ErrorPage(): JSX.Element {
  const intl = useIntl()
  return (
    <FlexContainer
      title={intl.formatMessage(headerText)}
      justifyContent="center"
      direction="column"
      gap="small"
      alignItems="center"
    >
      <Image src={require(`./resources/images/error-sign.png`)} altText="error sign" width="300px" />
      <H1 sx={{ textAlign: "center" }}>{intl.formatMessage(headerText)}</H1>
      <Text align="center">
        <FormattedMessage
          defaultMessage="Try reloading this page. If the problem persists, {br} feel free to <TextLink>contact us </TextLink>."
          values={{
            br: <br />,
            TextLink: (chunks) => (
              <TextLink size="medium" to="/send-a-message">
                {chunks}
              </TextLink>
            )
          }}
        />
      </Text>
    </FlexContainer>
  )
}
